import { Controller } from 'stimulus';
import moment from 'moment';

export default class extends Controller {
  static targets = [
    'deadline',
    'deadlineError',
    'tooshort',
    'tooearly',
    'copiedToMembersCheckbox',
    'copiedToMembersWarning',
    'hideTeamMembersCheckbox',
  ];

  // YYYY-MM-DD; empty when the server does not enforce a minimum deadline.
  static values = { minDeadline: String };

  connect() {
    this.element.addEventListener('ajax:success', (event) => {
      const [data] = event.detail;
      window.toastr.success(data.message);
      this.enableFormElements();
    });

    this.element.addEventListener('ajax:error', (event) => {
      const [data] = event.detail;
      window.toastr.error(data.message);
      this.enableFormElements();
    });
  }

  // Mirrors Fundraiser#ensure_minimum_deadline so the server-rendered error
  // only goes away once the user picks a date the server would accept.
  validateDeadline() {
    if (!this.hasDeadlineErrorTarget) return;

    const valid = this.deadlineValid();

    this.deadlineErrorTarget.classList.toggle('hidden', valid);
    // Rails wraps the label and input in .field_with_errors; clear that
    // styling along with the message.
    this.deadlineErrorWrappers().forEach((wrapper) => {
      wrapper.classList.toggle('field_with_errors', !valid);
    });
  }

  // Memoized: once the class is removed the wrappers can no longer be found
  // by selector, but they must be re-flagged if the user picks a bad date again.
  deadlineErrorWrappers() {
    if (!this.cachedDeadlineErrorWrappers) {
      const label = this.element.querySelector(
        `label[for="${this.deadlineTarget.id}"]`,
      );

      this.cachedDeadlineErrorWrappers = [this.deadlineTarget, label]
        .filter(Boolean)
        .map((el) => el.closest('.field_with_errors'))
        .filter(Boolean);
    }

    return this.cachedDeadlineErrorWrappers;
  }

  deadlineValid() {
    if (!this.minDeadlineValue) return true;

    // Both are YYYY-MM-DD, so string comparison orders them correctly.
    return this.deadlineTarget.value >= this.minDeadlineValue;
  }

  change(event) {
    if (
      moment(this.deadlineTarget.value).diff(moment(), 'weeks') < 3 &&
      moment(this.deadlineTarget.value).diff(moment(), 'hours') > 72
    ) {
      const otherController = this.application.getControllerForElementAndIdentifier(
        this.tooshortTarget,
        'modal',
      );
      otherController.open(event);
    }

    if (
      moment(this.deadlineTarget.value).diff(moment(), 'hours') < 72 &&
      this.tooearlyTarget
    ) {
      const otherController = this.application.getControllerForElementAndIdentifier(
        this.tooearlyTarget,
        'modal',
      );
      otherController.open(event);
    }

    if (
      this.copiedToMembersCheckboxTarget.checked &&
      this.copiedToMembersWarningTarget
    ) {
      const otherController = this.application.getControllerForElementAndIdentifier(
        this.copiedToMembersWarningTarget,
        'modal',
      );
      otherController.open(event);
    }
  }

  updateHideTeamMembers() {
    this.element.requestSubmit();
    this.disableFormElements();
  }

  disableFormElements() {
    this.hideTeamMembersCheckboxTarget.disabled = true;
  }

  enableFormElements() {
    this.hideTeamMembersCheckboxTarget.disabled = false;
  }
}
